var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-1",
    attrs: {
      headers: _vm.config.headers,
      items: _vm.dataTable,
      pagination: _vm.pagination,
      "rows-per-page-items": _vm.rowsPerPageItems,
      search: _vm.search
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function(props) {
          return [
            _vm._l(_vm.fieldsColum, function(header) {
              return _c("td", { key: header.value }, [
                _vm._v("\n      " + _vm._s(props.item[header.value]) + "\n    ")
              ])
            }),
            _c(
              "td",
              { staticClass: "layout px-0" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      icon: "",
                      flat: "",
                      color: "primary",
                      title: "Editar"
                    },
                    on: {
                      click: function($event) {
                        return _vm.clasificate(props.item)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("edit")])],
                  1
                )
              ],
              1
            )
          ]
        }
      },
      {
        key: "no-data",
        fn: function() {
          return [
            _c("div", { staticClass: "center" }, [
              _vm._v(
                "\n      No se han encontrado resultados para la búsqueda.\n    "
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }